"use strict";

var CODE = window.CODE || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    mq: 'LANDSCAPE',
    scrollTop: 0,
    winW: 0,
    winH: 0
  },
  common: {
    init: {}
  }
};
CODE.common = function () {
  /* ============================
   * 初期化
   * ============================ */
  function init(pageScript) {
    setUtilityData();
    setBrowser();
    if ($('.js-anchorLink')[0]) initAnchorLink();
    if (pageScript) pageScript();
  }

  /* ============================
   * ユーティリティデータ
   * 特定ページのみで使用するデータはページJSで取得すること
   * ============================ */
  function setUtilityData() {
    CODE.data.url = window.location.pathname;
    getScrollTop();
    CODE.data.$window.on('scroll', getScrollTop);
    getWindowSize();
    CODE.data.$window.on('resize', getWindowSize);
  }
  var scrollFlag = false;
  function getScrollTop() {
    if (scrollFlag) return;
    scrollFlag = true;
    requestAnimationFrame(function () {
      scrollFlag = false;
      CODE.data.scrollTop = CODE.data.$window.scrollTop();
      CODE.data.$window.trigger('scroll.custom');
    });
  }
  function getWindowSize() {
    CODE.data.winW = CODE.data.$window.width();
    CODE.data.winH = CODE.data.$window.height();
    var cssContent = $('body').css('content');
    var prevMQ = CODE.data.mq;
    CODE.data.mq = cssContent.indexOf('portrait') !== -1 ? 'PORTRAIT' : 'LANDSCAPE';
    if (prevMQ && prevMQ !== CODE.data.mq) {
      CODE.data.$window.trigger('onBreakpointChange');
    }
  }
  // CODE.data.$window.on('onBreakpointChange', callback);

  /* ============================
   * ブラウザ判定
   * ============================ */
  function setBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    CODE.data.ua = {
      Touch: 'ontouchstart' in document,
      Mobile: /iphone|ipod|android.*mobile/.test(ua),
      Tablet: /ipad/.test(ua) || /macintosh/.test(ua) && 'ontouchend' in document || /android/.test(ua) && !/mobile/.test(ua)
    };
    if (CODE.data.ua.Tablet) {
      $('html').addClass('tablet');
    }
  }

  /* ============================
   * アンカーリンク
   * ============================ */
  function initAnchorLink() {
    $('.js-anchorLink').on('click', function () {
      var href = $(this).attr('href');
      var $target = $(href === '#' || href === '' ? 'html' : href);
      var offset = $target.offset().top;
      $('html, body').animate({
        scrollTop: offset
      }, 500);
      return false;
    });
  }

  /* ============================
   * ストレージ
   * ============================ */
  function setSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }
  function getSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }
  function getLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  /* ============================
   * 画像読み込みカウンタ
   * Promiseを返す。onProgressで進捗を取得可能
   * ============================ */
  function countImgLoaded(target, onProgress) {
    var $imgs = target ? target.find('img') : $('img');
    var total = $imgs.length;
    var count = 0;
    return new Promise(function (resolve, reject) {
      $imgs.each(function () {
        var img = new Image();
        img.src = $(this).attr('src');
        img.onload = function () {
          count++;
          if (onProgress) onProgress(count / total);
          if (count >= total) resolve();
        };
        img.onerror = function () {
          return reject();
        };
      });
    });
  }

  /* ============================
   * スクロールロック
   * ============================ */
  function screenLock() {
    $('html').addClass('scrollLock');
  }
  function screenUnlock() {
    $('html').removeClass('scrollLock');
  }
  return {
    init: init,
    setSessionStorage: setSessionStorage,
    getSessionStorage: getSessionStorage,
    setLocalStorage: setLocalStorage,
    getLocalStorage: getLocalStorage,
    countImgLoaded: countImgLoaded,
    screenLock: screenLock,
    screenUnlock: screenUnlock
  };
}();